<template>
  <div class="ibox-body">
    <div class="ibox-title style_2" style="display: flex; justify-content: space-between; align-items: center;">
      <h5>{{ title }}</h5>
      <div class="position-relative align-self-center" 
              aria-label="Create Visit" tabindex="0">
              <img class="cursor-pointer" src="../../assets/img/create.png" width="17" height="15" alt="Create Visit"
                 @click.prevent="visitPopup(0, '')"/>
              <div class="tool-tip">{{ $t("navigations.create visit") }}</div>
            </div>
    </div>

    <!-- LOADING -->
    <div class="text-center" v-if="loading === true">
      <img src="../../assets/img/loading.gif" width="15" alt="Waiting for login" />
      <div>{{ $t("navigations.please wait while the list is being loaded") }}</div>
    </div>

    <!-- VISIT TREE -->
    <div v-else class="ibox-content horizondalscroll" id="scrollBody">
      <ul class="tree pl-1">
        <li v-for="(visit, vIndex) in visitList" :key="visit.visitId">

          <!-- Visit Header -->
          <div class="d-flex justify-content-between align-items-center">

            <!-- Checkbox + Label -->
            <div>
              <input type="checkbox"
                     :id="visit.visitId"
                     @change="toggleVisit(vIndex, visit.visitId)" />

              <label class="tree_label" :for="visit.visitId">
                {{ visit.visitNo }} : {{ visit.visitFormName }}
              </label>
            </div>

            <!-- ACTION ICONS -->
            <div class="d-flex align-items-center gap-3">

              <!-- 3 dots menu -->
              <div class="position-relative">
                <button
                  :popovertarget="'visit-popup-' + visit.visitId"
                  :anchor="'visit-popup-' + visit.visitId"
                  class="tmf-doc-ellipsis-btn border-0 bg-transparent cursor-pointer px-2 py-0 pt-2">
                  <i class="fa fa-ellipsis-v"></i>
                </button>

                <div :id="'visit-popup-' + visit.visitId" popover class="tmf-docs-popup-menu"  @click.stop>
                  <button class="popup-menu-block text-start" @click.prevent="visitPopup(visit.visitId)">
                    {{ $t('navigations.edit') }}
                  </button>

                  <button class="popup-menu-block text-start" @click.prevent="deleteVisit(visit.visitId)">
                    {{ $t('navigations.delete') }}
                  </button>

                  <button class="popup-menu-block text-start" @click.prevent="openVisitActivityModal(visit.visitId)">
                    {{ $t('navigations.assign activity') }}
                  </button>
                </div>
              </div>

            </div>
          </div>

          <!-- Activities & Forms (FIXED v-if + v-for issue) -->
          <div v-if="visitExpanded[vIndex]">
            <ul
              v-for="(activity, aIndex) in activityList[visit.visitId][vIndex]"
              :key="activity.activityId"
            >
              <li>
                <input
                  type="checkbox"
                  :id="activity.activityId+visit.visitId"
                  @change="getActivityForms(activity.activityId, aIndex)"
                />

                <label :for="activity.activityId+visit.visitId" class="tree_label">
                  {{ activity.activityOrder }} : {{ activity.activityName }}
                </label>

                <!-- FORMS -->
                <ul
                  v-for="form in formList[activity.activityId][aIndex]"
                  :key="form.templateId"
                >
                  <li>
                    <label :for="form.templateId" class="tree_label">
                      {{ form.templateName }} : {{ form.version }}
                    </label>

                    <input
                      type="checkbox"
                      :id="form.templateId"
                      @change="viewForms(form.templateId)"
                    />
                  </li>
                </ul>

              </li>
            </ul>
          </div>

        </li>
      </ul>
    </div>
  </div>

  <!-- MODALS -->
  <showformmodel
    v-if="setshowActivityFormModal"
    :formid="formActivityId"
    currentformstatus="not completed"
    @closeformModal="closeformActivityModal()" />

  <VisitActivityModal
    v-if="showActivityModal"
    :visitId="SelectedVisitId"
    :version="selectedVersion"
    @closeModal="closeActivityModal()" />

  <manageVisitModal
    v-if="showSiteModal"
    :visitId="visitId"
    :version="selectedVersion"
    @closeModal="closeModal()"
    @visitSaved="openVisitActivityModal" />
</template>

<script src="./VisitActivityTree.js"></script>

<style scoped>
.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.tmf-docs-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.tmf-docs-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.tmf-docs-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.tmf-docs-popup-menu > button {
  width: 100%;
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.tmf-docs-popup-menu > .popup-menu-block:hover {
  background-color: #e4eaf9;
}
.position-relative .tool-tip {
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 20px;
  top: -10px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}
</style>
